
if (!window.polyfillDone) {
	window.polyfillDone = true;
	navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.oGetUserMedia || navigator.msGetUserMedia;
	window.MediaSource = window.MediaSource || window.WebKitMediaSource || window.mozMediaSource;
	window.URL = window.URL || window.webkitURL || window.mozURL;
	window.performance = window.performance || { now: (function(){return Date.now()}) };
	window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.msAudioContext;
}
export default window.polyfillDone